module.exports = __webpack_public_path__ + "static/media/lyftLogoPink.2693c19a.png";